import React from 'react';
import PropTypes from 'prop-types';

import IssueCommentField from './components/IssueCommentField';
import ErrorTypesField from './components/ErrorTypesField';
import SeverityOptionsField from './components/SeverityOptionsField';
import SubmitAnnotationField from './components/SubmitAnnotationField';
import { ICON_PATH } from '../../constants';
import './QualityIssueContainer.css';

const isAnnotationSubmittable = ({ errorType, severity }) => {
  if (!errorType) {
    return false;
  }
  if (!severity) {
    return false;
  }
  return true;
};

class QualityIssueContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      annotation: props.annotation,
      isSubmittable: false,
      isSubmitting: false,
    };

    this.setErrorType = this.setErrorType.bind(this);
    this.setSeverity = this.setSeverity.bind(this);
    this.setComment = this.setComment.bind(this);
    this.updateAnnotation = this.updateAnnotation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setErrorType(errorType) {
    this.updateAnnotation({ errorType });
  }

  setSeverity(severity) {
    this.updateAnnotation({ severity });
  }

  setComment(comment) {
    this.updateAnnotation({ comment });
  }

  updateAnnotation(updatedAnnotation) {
    const { annotation: stateAnnotation } = this.state;
    const annotation = { ...stateAnnotation, ...updatedAnnotation };
    this.setState({
      isSubmittable: isAnnotationSubmittable(annotation),
      annotation,
    });
  }

  async handleSubmit() {
    const { isSubmitting } = this.state;
    if (isSubmitting) {
      return;
    }
    this.setState({ isSubmitting: true });
    const { onSubmit } = this.props;
    const { annotation } = this.state;
    await onSubmit(annotation);
  }

  render() {
    const { gocheckVersion, onClose } = this.props;
    const { annotation: { severity, errorType, comment }, isSubmittable } = this.state;

    return (
      <div className="annotator-issue">
        <span className="annotator-heading">
          <img className="icon" src={`${ICON_PATH}/quality-issue-icon-yellow.svg`} alt="Issue" />
          Quality Issue
        </span>
        <SeverityOptionsField
          gocheckVersion={gocheckVersion}
          value={severity}
          onChange={this.setSeverity}
        />
        <ErrorTypesField value={errorType} onChange={this.setErrorType} />
        <IssueCommentField value={comment} onChange={this.setComment} />
        <SubmitAnnotationField
          isSubmittable={isSubmittable}
          onSubmit={this.handleSubmit}
          onCancel={onClose}
        />
      </div>
    );
  }
}

QualityIssueContainer.propTypes = {
  gocheckVersion: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  annotation: PropTypes.shape({
    id: PropTypes.number,
    errorType: PropTypes.string,
    severity: PropTypes.string,
    comment: PropTypes.string,
  }).isRequired,
};

export default QualityIssueContainer;
